import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'components/FormFields';
import Filter from 'components/Filter';
import { getYesterday, getToday } from '../../helpers';
import { API_URL } from '../../../../constants/api';
import './ChartFilter.css';
import { logoutAction } from '../../../sign-in/actions';
import * as ROUTES from '../../../../constants/routes';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { downloadFileRequest } from '../../../../actions/exportFile';

const getDate = (date, defaultDate = null) => {
    if (date) return new Date(date);
    return defaultDate;
};

const ChartFilter = ({ onChangeFilter, initialValues }) => {
    const today = new Date();
    const yesterday = new Date(getYesterday());
    const dispatch = useDispatch();
    const history = useHistory();

    const handleClick = async (startDate, endDate) => {
        try {
            await downloadFileRequest(API_URL, today, startDate, endDate);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const onLogout = () => {
        dispatch(logoutAction()).then(() => history.replace(ROUTES.SIGN_IN_PATH));
    };

    const datetime1 = initialValues.datetime2 !== undefined ? initialValues.datetime2 : getYesterday();
    const datetime2 = initialValues.datetime !== undefined ? initialValues.datetime : getToday();

    return (
        <section className="section-container">
            <Filter>
                <DatePicker
                    label={'Дата'}
                    value={getDate(initialValues.datetime, today)}
                    onChange={(value) => onChangeFilter({ datetime: value })}
                />
                <DatePicker
                    label={'Дата сравнения'}
                    value={getDate(initialValues.datetime2, yesterday)}
                    onChange={(value) => onChangeFilter({ datetime2: value })}
                />
                <div>
                    <button className="button-style" onClick={() => handleClick(datetime1, datetime2)}>
                        Экспорт
                    </button>
                </div>
            </Filter>
            <div className="logout-button-container" onClick={onLogout}>
                <button className="button-style">Выйти</button>
            </div>
        </section>
    );
};

ChartFilter.propTypes = {
    onChangeFilter: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
};

export default ChartFilter;
